import React from 'react';
import { t } from 'i18next';
import { useParams } from 'react-router-dom';
import { LiliButton, LiliButtonType } from '@lili/lili-frontend-common';
import { successContentMap } from '../../consts';

interface DefaultFooterProps {
  handleAnotherTransfer: () => void;
  handleDone: () => void;
  isLoadingAndDisabled: boolean;
}

export const DefaultFooter = (props: DefaultFooterProps) => {
  const { handleAnotherTransfer, handleDone, isLoadingAndDisabled } = props;
  const { moveType } = useParams();

  return (
    <>
      <LiliButton
        type={LiliButtonType.SECONDARY}
        onClick={handleAnotherTransfer}
        isLoading={isLoadingAndDisabled}
        disabled={isLoadingAndDisabled}
        id='makeAnotherTransfer'
        className='w-[226px]'
        title={
          moveType &&
          t(successContentMap[moveType as keyof typeof successContentMap].secondary_cta, { defaultValue: successContentMap[moveType as keyof typeof successContentMap].secondary_cta })
        }
      />
      <LiliButton
        onClick={handleDone}
        id='continue'
        className='w-[226px]'
        title={
          moveType
            ? t(successContentMap[moveType as keyof typeof successContentMap].main_cta, { defaultValue: successContentMap[moveType as keyof typeof successContentMap].main_cta })
            : ''
        }
      />
    </>
  );
};
